
import { Component, Mixins } from 'vue-property-decorator';
import PendingShipments from '@/features/schedule-pickup/components/PendingShipments.vue';
import NoPickupModal from '@/features/schedule-pickup/components/NoPickupModal.vue';
import SchedulePickupFlow from '@/features/schedule-pickup/components/SchedulePickupFlow.vue';
import { noPickupRequired } from '@/features/schedule-pickup/services/schedulePickup.services';
import { showErrorAlertDialog } from '@/features/common/helpers';
import {
  SchedulePickupResponse,
  SelectedUnscheduledPickup,
} from '@/features/schedule-pickup/types';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { showFloatingWidgets, hideFloatingWidgets, addStyleToScrollToTopBtn } from '@/features/feedback-tool/helpers';

@Component({
  components: {
    NoPickupModal,
    PendingShipments,
    SchedulePickupFlow,
  },
})
export default class Schedule extends Mixins(ResponsivenessMixin) {
  private showPickupSpecificsModal = false;

  private showNoPickupModal = false;

  private oopsShow = false;

  private showDifferentCarriersDialog = false;

  private isShipmentsAvailable = false;

  private pickupResponse: SchedulePickupResponse | null = null;

  private selectedPickups: SelectedUnscheduledPickup[] = [];

  private hideFloatingWidgets = hideFloatingWidgets;

  private get hasSelectedPickups(): boolean {
    return this.selectedPickups.length > 0;
  }

  private showFloatingWidgets = showFloatingWidgets;

  private addStyleToScrollToTopBtn = addStyleToScrollToTopBtn;

  destroyed(): void {
    window.removeEventListener('resize', this.handleResize);
    this.showFloatingWidgets();
    this.addStyleToScrollToTopBtn({
      bottom: '20px',
    });
  }

  mounted(): void {
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleResize();
      this.addStyleToScrollToTopBtn({
        bottom: '80px',
      });
    }, 3000);
  }

  private handleResize() {
    if (window.innerWidth < 720 && this.isShipmentsAvailable) {
      this.hideFloatingWidgets();
      return;
    }
    this.showFloatingWidgets();
  }

  private openPickupModal(): void {
    if (!this.selectedPickups.length) {
      showErrorAlertDialog(
        this.$t('scheduledPickups.pleaseSelectAShipment') as string,
      );
      return;
    }

    if (this.selectedPickups.length > 1) {
      const firstCarrierCode = this.selectedPickups[0]?.carrierCode;
      if (firstCarrierCode) {
        const hasDifferentCarriers = this.selectedPickups.some(
          (pickup) => pickup.carrierCode !== firstCarrierCode,
        );

        if (hasDifferentCarriers) {
          this.showDifferentCarriersDialog = true;
          return;
        }
      }
    }

    this.showPickupSpecificsModal = true;
  }

  private openNoPickupModal(): void {
    if (!this.selectedPickups.length) {
      showErrorAlertDialog(
        this.$t('scheduledPickups.pleaseSelectAShipment') as string,
      );
      return;
    }

    this.showNoPickupModal = true;
  }

  private async noPickupRequired() {
    if (!this.selectedPickups.length) return;

    this.pickupResponse = await noPickupRequired(
      this.selectedPickups.map((item) => item.trackingNumber),
    );

    this.showNoPickupModal = false;

    if (this.pickupResponse && this.pickupResponse.successful) {
      this.$router.push({ name: 'dropoff-requested-confirm' });
      this.selectedPickups = [];
      return;
    }

    this.oopsShow = true;
  }
}
